import React, { useState } from "react";
import { currentAffairsData } from "../../data/staticData";

export default function Daily() {
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedMonth, setSelectedMonth] = useState(
    new Date().toLocaleString("default", { month: "long" })
  );
  const [selectedYear, setSelectedYear] = useState("2025");

  const [dailyPage, setDailyPage] = useState(1);
  const [monthlyPage, setMonthlyPage] = useState(1);
  const itemsPerPage = 5;

  // Filters
  const currentDaily = currentAffairsData.filter(
    (item) =>
      item.filterType === "Daily" &&
      new Date(item.createdAt).toISOString().split("T")[0] === selectedDate
  );

  const currentMonthly = currentAffairsData.filter(
    (item) =>
      item.filterType === "Monthly" &&
      item.month === selectedMonth &&
      item.year === selectedYear
  );

  // Pagination logic
  const paginate = (data, page) => {
    const start = (page - 1) * itemsPerPage;
    return data.slice(start, start + itemsPerPage);
  };

  const totalDailyPages = Math.ceil(currentDaily.length / itemsPerPage);
  const totalMonthlyPages = Math.ceil(currentMonthly.length / itemsPerPage);

  const handleOpenFile = (url) => {
    if (!url) {
      alert("Document not available.");
      return;
    }
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <section className="relative w-full px-4 py-10 bg-gray-50 space-y-12">
      <div className="max-w-6xl mx-auto space-y-10">
        {/* Daily Current Affairs */}
        <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-red-700">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
            <h2 className="text-2xl font-bold text-red-800">
              Daily Current Affairs
            </h2>
            <input
              type="date"
              value={selectedDate}
              onChange={(e) => {
                setSelectedDate(e.target.value);
                setDailyPage(1);
              }}
              className="border border-red-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 mt-3 md:mt-0"
            />
          </div>

          {currentDaily.length === 0 ? (
            <p className="text-gray-600">
              No current affairs available for this date.
            </p>
          ) : (
            <>
              <div className="space-y-4">
                {paginate(currentDaily, dailyPage).map((item) => (
                  <div
                    key={item._id}
                    className="p-5 bg-red-50 border border-red-200 rounded-lg hover:shadow-md transition flex flex-col md:flex-row justify-between items-start md:items-center"
                  >
                    <div>
                      <h3 className="font-semibold text-red-800 text-lg">
                        {item.title}
                      </h3>
                      <p className="text-gray-700 text-sm mt-1">
                        {item.description}
                      </p>
                      <div className="text-xs text-gray-500 mt-2">
                        📅{" "}
                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                      </div>
                    </div>
                    {item.fileUrl && (
                      <button
                        onClick={() => handleOpenFile(item.fileUrl)}
                        className="mt-3 md:mt-0 bg-red-700 text-white text-sm px-4 py-2 rounded hover:bg-red-800 transition"
                      >
                        Open File
                      </button>
                    )}
                  </div>
                ))}
              </div>

              {totalDailyPages > 1 && (
                <div className="flex justify-center mt-5 space-x-2">
                  {Array.from({ length: totalDailyPages }, (_, i) => (
                    <button
                      key={i}
                      onClick={() => setDailyPage(i + 1)}
                      className={`px-3 py-1 rounded ${
                        dailyPage === i + 1
                          ? "bg-red-700 text-white"
                          : "bg-red-100 text-red-700"
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>

        {/* Monthly Current Affairs */}
        <div className="bg-white rounded-xl shadow-lg p-6 border-t-4 border-blue-900">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
            <h2 className="text-2xl font-bold text-blue-900">
              Monthly Current Affairs
            </h2>
            <div className="flex space-x-3 mt-3 md:mt-0">
              <select
                value={selectedMonth}
                onChange={(e) => {
                  setSelectedMonth(e.target.value);
                  setMonthlyPage(1);
                }}
                className="border border-blue-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <option key={m}>{m}</option>
                ))}
              </select>
              <select
                value={selectedYear}
                onChange={(e) => {
                  setSelectedYear(e.target.value);
                  setMonthlyPage(1);
                }}
                className="border border-blue-600 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {[2025, 2024, 2023].map((y) => (
                  <option key={y}>{y}</option>
                ))}
              </select>
            </div>
          </div>

          {currentMonthly.length === 0 ? (
            <p className="text-gray-600">
              No current affairs available for this month.
            </p>
          ) : (
            <>
              <div className="space-y-4">
                {paginate(currentMonthly, monthlyPage).map((item) => (
                  <div
                    key={item._id}
                    className="p-5 bg-blue-50 border border-blue-200 rounded-lg hover:shadow-md transition flex flex-col md:flex-row justify-between items-start md:items-center"
                  >
                    <div>
                      <h3 className="font-semibold text-blue-800 text-lg">
                        {item.title}
                      </h3>
                      <p className="text-gray-700 text-sm mt-1">
                        {item.description}
                      </p>
                      <div className="text-xs text-gray-500 mt-2">
                        📅{" "}
                        {new Date(item.createdAt).toLocaleDateString("en-IN")}
                      </div>
                    </div>
                    {item.fileUrl && (
                      <button
                        onClick={() => handleOpenFile(item.fileUrl)}
                        className="mt-3 md:mt-0 bg-blue-700 text-white text-sm px-4 py-2 rounded hover:bg-blue-800 transition"
                      >
                        Open File
                      </button>
                    )}
                  </div>
                ))}
              </div>

              {totalMonthlyPages > 1 && (
                <div className="flex justify-center mt-5 space-x-2">
                  {Array.from({ length: totalMonthlyPages }, (_, i) => (
                    <button
                      key={i}
                      onClick={() => setMonthlyPage(i + 1)}
                      className={`px-3 py-1 rounded ${
                        monthlyPage === i + 1
                          ? "bg-blue-700 text-white"
                          : "bg-blue-100 text-blue-700"
                      }`}
                    >
                      {i + 1}
                    </button>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </section>
  );
}
